import React from 'react';

const ManageProjects = () => {
  return <div>No Project Available</div>;
};

export default ManageProjects;
